import React from "react";

type ParagraphProps = {
  className?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLParagraphElement>;

const Paragraph = ({
  className = "",
  children,
  ...props
}: ParagraphProps) => {
  return (
    <p className={className} {...props}>
      {children}
    </p>
  );
};

export default Paragraph;
